import styles from './RecommendationDebugInfo.module.scss'

import React, { useRef, useState } from 'react'

import PropTypes from 'prop-types'

import Modal from 'Components/Modal/ModalWithPortal.js'

import Button from 'Molecules/Button/Button'
import ClickToCopy from 'Molecules/ClickToCopy/ClickToCopy'

import Svg from 'Atoms/Svg/Svg'
import Typography from 'Atoms/Typography/Typography'

const RecommendationDebugInfo = ({ misoRequestJson }) => {
  const modal = useRef(null)

  const formattedJson =
    typeof misoRequestJson === 'string'
      ? JSON.stringify(JSON.parse(misoRequestJson), null, 2)
      : JSON.stringify(misoRequestJson, null, 2)

  const openModal = () => modal.current.open()

  return (
    <>
      <div className={styles.recDebugIconWrapper} onClick={openModal}>
        <Svg icon={'info'} size={1} className={styles.recDebugIcon} hoverable />
      </div>
      <Modal ref={modal} outsideClick={true}>
        <div className={styles.recDubugInfo}>
          <div className={styles.modalHeader}>
            <Typography className={styles.modalTitle}>Miso Request Debug Info</Typography>
          </div>
          <div className={styles.jsonPreContainer}>
            <ClickToCopy textToCopy={misoRequestJson} className={styles.copy} />
            <pre className={styles.jsonPre}>{formattedJson}</pre>
          </div>
        </div>
      </Modal>
    </>
  )
}

RecommendationDebugInfo.propTypes = {
  misoRequestJson: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
}

export default RecommendationDebugInfo
